module.exports = __webpack_public_path__ + "img/tag_processing.8765a6db.png";